import axios from 'axios';
import { Fuel, Wrench, CircleDot, Receipt } from 'lucide-react';

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const errMsg = (e, fallback) => e?.response?.data?.detail || fallback;

export const rand = (n) => `R${Number(n || 0).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const CATEGORIES = [
  { value: 'petrol', label: 'Petrol', icon: Fuel, color: 'text-amber-600 bg-amber-50' },
  { value: 'repairs', label: 'Repairs', icon: Wrench, color: 'text-sky-700 bg-sky-50' },
  { value: 'tyres', label: 'Tyres', icon: CircleDot, color: 'text-slate-700 bg-slate-100' },
  { value: 'other', label: 'Other', icon: Receipt, color: 'text-violet-700 bg-violet-50' },
];

export const categoryMeta = (v) => CATEGORIES.find((c) => c.value === v) || CATEGORIES[3];

export const fetchFileUrl = async (token, kind, id) => {
  const res = await axios.get(`${API_URL}/finance/files/${kind}/${id}`, { ...auth(token), responseType: 'blob' });
  return { url: URL.createObjectURL(res.data), type: res.data.type };
};
